import { API_ROUTES } from "Api/Api";
import { downloadFile } from "Utils/FileUtils";
import { put, takeLatest } from "redux-saga/effects";
import { createAsyncAction } from "typesafe-actions";
import { getType } from "typesafe-actions";

export const downloadEmployeeGuideAsync = createAsyncAction(
  "@invoice/DOWNLOAD_EMPLOYEE_GUIDE_REQUEST",
  "@invoice/DOWNLOAD_EMPLOYEE_GUIDE_SUCCESS",
  "@invoice/DOWNLOAD_EMPLOYEE_GUIDE_FAILURE",
)<void, void, Error>();

function* downloadEmployeeGuide(
  action: ReturnType<typeof downloadEmployeeGuideAsync.request>,
): Generator {
  try {
    const route = `${import.meta.env.VITE_API_URL}${
      API_ROUTES.postInvoiceDownloadEmployeeGuide
    }`;
    const response = yield* downloadFile(route, "POST");

    if (response.clone.status === 200) {
      response.clone.blob().then((_blob) => {
        // FileSaver.saveAs(blob, "Pokyn pro zaměstnavatele.pdf"); //TODO: uncomment and refactor if needed
      });
      yield put(downloadEmployeeGuideAsync.success());
    } else {
      yield put(
        downloadEmployeeGuideAsync.failure(
          new Error(`Error in action ${action.type}`, {
            cause: response.clone.status,
          }),
        ),
      );
    }
  } catch (err) {
    yield put(downloadEmployeeGuideAsync.failure(err as Error));
  }
}

export function* downloadEmployeeGuideSaga() {
  yield takeLatest(
    getType(downloadEmployeeGuideAsync.request),
    downloadEmployeeGuide,
  );
}
